<template>
  <div class="logo">
    <router-link :to="{path:'/'}">
      <img style="width: 55px;height: 55px;" src="@/assets/images/officia-logo.png" alt="logo" />
      <h1 v-if="showTitle">{{ projectName }}</h1>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
